import Comp from './SignupPage';

export default Comp;
